var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",style:({
        'background': 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(' + _vm.image + ') center',
        'background-size': 'cover'
    })},[_c('h2',{staticClass:"title has-text-white"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('br'),_c('b',[_vm._v(_vm._s(_vm.conclusion))])])])}
var staticRenderFns = []

export { render, staticRenderFns }